(function () {
  function closestMediaContainer(target) {
    if (!document.body || !document.body.classList.contains('template-product')) return null;
    return target && target.closest ? target.closest('.productView-image .productView-img-container') : null;
  }

  document.addEventListener('pointerover', function (event) {
    var container = closestMediaContainer(event.target);
    if (!container) return;
    container.classList.add('is-dyu-media-hover');
  }, true);

  document.addEventListener('pointerout', function (event) {
    var container = closestMediaContainer(event.target);
    if (!container) return;
    if (event.relatedTarget && container.contains(event.relatedTarget)) return;
    container.classList.remove('is-dyu-media-hover');
  }, true);

  document.addEventListener('focusin', function (event) {
    var container = closestMediaContainer(event.target);
    if (container) container.classList.add('is-dyu-media-hover');
  });

  document.addEventListener('focusout', function (event) {
    var container = closestMediaContainer(event.target);
    if (container) container.classList.remove('is-dyu-media-hover');
  });
})();
